import { useState } from "react";

import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import { postActiveEmployes } from "../../../../../MyApi/sb/employes";

import EmployesAttendance from "../employesTabContent/employesAttendance";
import EmployesAttachments from "../employesTabContent/employesAttachments";
import EmployesRequests from "../employesTabContent/employesRequests";
import EmployesPayrolls from "../employesTabContent/employesPayrolls";

import icons from "../../../../../Data/icons";
import classes from "../../../../../assets/css/showCardInfo.module.css";
import EmployesVisits from "../employesTabContent/employesVisits";

const EmployesDetalis = ({ employes }) => {
  const { id, name_ar, name_en, role, nation_id, mobile, active, image } =
    employes;
  const [activeState, setActive] = useState(active);
  const [activeTab, setActiveTab] = useState("attendance");
  const mutation = useMutation(
    ["postActive", id],
    (postData) => postActiveEmployes(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );
  const { t } = useTranslation();

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const handelChangeActive = (e) => {
    const isChecked = e.target.checked;
    const newActiveState = isChecked ? 1 : 0;

    setActive(newActiveState);
    mutation.mutate({
      active: newActiveState,
    });
  };

  const titles = {
    id: "#",
    name_ar: t("Name_Ar"),
    name_en: t("Name_En"),
    mobile: t("Mobile"),
    role: t("role"),
    nation: t("nation_id"),
  };
  const IdCardIcon = icons.idCard;
  const PhoneIcon = icons.phone;
  const AbcIcon = icons.abc;
  const RoleIcon = icons.role;

  return (
    <div className={classes.container}>
      <div className="user-profile">
        <div class="row">
          <div class="col-md-6">
            <div class="profile-header bg-size card bg-primary">
              <div class="userpro-box">
                <div class="img-wrraper">
                  <div class="avatar">
                    <img src={image} alt={name_ar} />
                  </div>
                  <div class="icon-wrapper">
                    <Link to={`${process.env.PUBLIC_URL}/employesupdate/${id}`}>
                      {" "}
                      <i
                        class="icofont icofont-pencil-alt-5"
                        data-intro="Change Profile image here"></i>{" "}
                    </Link>
                  </div>
                </div>
                <div class="user-designation">
                  <div class="title m-0">
                    <h4>{name_ar}</h4>
                    <h6>{name_en}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div className={classes.tableCard}>
              <div className={classes.tableCardBody}>
                <ul className={classes.ListGroup}>
                  <li className={classes.listItemGroup}>
                    <div className={classes.listIcon}>
                      <IdCardIcon />
                    </div>
                    <div>
                      <h5 className={classes.listTitle}>{titles.id}</h5>
                      <p>{id}</p>
                    </div>
                  </li>
                  <li className={classes.listItemGroup}>
                    <div className={classes.listIcon}>
                      <AbcIcon />
                    </div>
                    <div>
                      <h5 className={classes.listTitle}>{titles.name_ar}</h5>
                      <p className={classes.listPargrah}>{name_ar}</p>
                    </div>
                  </li>
                  <li className={classes.listItemGroup}>
                    <div className={classes.listIcon}>
                      <AbcIcon />
                    </div>
                    <div>
                      <h5 className={classes.listTitle}>{titles.name_en}</h5>
                      <p className={classes.listPargrah}>{name_en}</p>
                    </div>
                  </li>
                  <li className={classes.listItemGroup}>
                    <div className={classes.listIcon}>
                      <PhoneIcon />
                    </div>
                    <div>
                      <h5 className={classes.listTitle}>{titles.mobile}</h5>
                      <p className={classes.listPargrah}>{mobile}</p>
                    </div>
                  </li>
                  <li className={classes.listItemGroup}>
                    <div className={classes.listIcon}>
                      <IdCardIcon />
                    </div>
                    <div>
                      <h5 className={classes.listTitle}>{titles.nation}</h5>
                      <p className={classes.listPargrah}>{nation_id}</p>
                    </div>
                  </li>

                  <li className={classes.listItemGroup}>
                    <div className={classes.listIcon}>
                      <RoleIcon />
                    </div>
                    <div>
                      <h5 className={classes.listTitle}>{titles.role}</h5>
                      <p className={classes.listPargrah}>{role}</p>
                    </div>
                  </li>

                  <li className={classes.listItemGroup}>
                    <div className={classes.listIcon}>
                      <RoleIcon />
                    </div>
                    <div>
                      <h5 className={classes.listTitle}>
                        {" "}
                        {activeState === 1 ? " نشط" : "غير نشط"}
                      </h5>
                      <div className={classes.formCol}>
                        <label
                          htmlFor="active"
                          className={
                            activeState
                              ? `${classes.active}`
                              : `${classes.disActive}`
                          }>
                          {" "}
                        </label>

                        <label class="switch">
                          <input
                            type="checkbox"
                            onChange={handelChangeActive}
                            checked={activeState}
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 box-col-12">
          <div class="card">
            <div class="social-tab">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "attendance" && "active"
                    }`}
                    onClick={() => handleActiveTab("attendance")}>
                    سجل الحضور
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "attachments" && "active"
                    }`}
                    onClick={() => handleActiveTab("attachments")}>
                    المستندات
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "requests" && "active"
                    }`}
                    onClick={() => handleActiveTab("requests")}>
                    الطلبات
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className={`nav-link ${
                      activeTab === "salaries" && "active"
                    }`}
                    onClick={() => handleActiveTab("salaries")}>
                    المرتبات
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className={`nav-link ${activeTab === "tasks" && "active"}`}
                    onClick={() => handleActiveTab("tasks")}>
                    المهام
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className={`nav-link ${activeTab === "visits" && "active"}`}
                    onClick={() => handleActiveTab("visits")}>
                    الزيارات
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="card">
            {activeTab === "attendance" && <EmployesAttendance id={id} />}
            {activeTab === "requests" && <EmployesRequests id={id} />}
            {activeTab === "attachments" && <EmployesAttachments id={id} />}
            {activeTab === "salaries" && <EmployesPayrolls id={id} />}
            {activeTab === "visits" && <EmployesVisits id={id} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployesDetalis;
